export default __webpack_public_path__ + "static/media/bf.f7376b2d.svg";